export default __webpack_public_path__ + "static/media/H.ef9a004f.png";